<script setup lang="ts">
const props = defineProps<{
    type: string
    html: string
}>()

const isYouTubeIframe = computed(() => {
    const srcMatch = props.html.match(/<iframe[^>]+src="([^"]+)"/)
    if (srcMatch) {
        const src = srcMatch[1]
        return src.includes('youtube')
    }
    return false
})
</script>

<template>
    <div
        :class="isYouTubeIframe ? 'yt-embedded' : 'embedded-code'"
        v-html="html"
    />
</template>

<style lang="scss">
.embedded-code {
    iframe {
        width: 100%;
        margin: 0 auto !important;
    }
    blockquote {
        margin: 1px auto !important;
    }
}
.yt-embedded {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
